import storage from "./storage.js";
/**
 *
 * StoreFrontSponsorStorageService
 *
 * @namespace StoreFrontSponsorStorageService
 */
var StoreFrontSponsorStorageService = function () {
    "use strict";

    var STORAGE_KEY = storage.metadata.STOREFRONT;

    // ---------------------------------------------
    //
    //            Define public methods
    //
    // ---------------------------------------------
    var publicMethods = {
        clearStoreFrontSponsor: function(){
            publicMethods.setStoreFrontSponsor(null);
        },
        getStoreFrontSponsor: function(){
            return storage.getItem(STORAGE_KEY);
        },
        setStoreFrontSponsor: function(sponsor){
            if (sponsor == null || typeof (sponsor) == 'undefined') {
                storage.removeItem(STORAGE_KEY);
            } else {
                storage.setItem(STORAGE_KEY, sponsor);
            }
        }
    };

    return publicMethods;
}();

export default StoreFrontSponsorStorageService;



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/node_modules/@nuskin/ns-util/src/storeFrontSponsorService.js
// module id = 300
// module chunks = 0